import React from 'react';

import Helm from '../../images/helm.svg';

export interface HelmLogoProps {
  size: 'small' | 'medium' | 'large';
  alt?: string;
}

const logoSizes = {
  small: 18,
  medium: 24,
  large: 32,
};

export const HelmLogo = ({ size, alt }: HelmLogoProps) => {
  return <img height={logoSizes[size]} src={Helm} alt={alt || 'Helm logo'} />;
};
